module.exports = __webpack_public_path__ + "static/media/gitTogether-preview.9c27caba.png";